"use strict";
// import { IUser } from '@faceyourmanga/fym-lib'
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNAVAILABLE_GDPR = exports.AUTH_UPDATE = void 0;
exports.AUTH_UPDATE = 'AUTH_UPDATE';
exports.UNAVAILABLE_GDPR = 'UNAVAILABLE_GDPR';
